
namespace TabAurous.OMS {

    @Serenity.Decorators.registerClass()
    export class LedgerPostingGrid extends Serenity.EntityGrid<LedgerPostingRow, any> {
        protected getColumnsKey() { return 'OMS.LedgerPosting'; }
        protected getDialogType() { return LedgerPostingDialog; }
        protected getIdProperty() { return LedgerPostingRow.idProperty; }
        protected getInsertPermission() { return LedgerPostingRow.insertPermission; }
        protected getLocalTextPrefix() { return LedgerPostingRow.localTextPrefix; }
        protected getService() { return LedgerPostingService.baseUrl; }
        private autoSize;
        constructor(container: JQuery) {
            super(container);
            this.setTitle("");
            this.slickGrid.setOptions({ rowHeight: 30 });

        }
        protected createSlickGrid(){
            let grid = super.createSlickGrid();
            this.autoSize = new Slick.AutoColumnSize();
            grid.registerPlugin(this.autoSize);
            grid.registerPlugin(new Slick.Data.GroupItemMetadataProvider());
            this.view.setGrouping([{ getter: 'LedgerName' }]);
            //this.view.setSummaryOptions({
            //    aggregators: [
            //        new Slick.Aggregators.Sum('VoucherTypeId')]
            //});       

            return grid;
        }
        
        protected getButtons(): Serenity.ToolButton[] {
          //  this.withBom = true;
            return [ {
                title: 'Export',
                cssClass: 'import-xlsx-button',
                //icon: 'fa-cloud-download',
                onClick: () => {
                 /*   let _stockItemRows: StockItemRow[] = [];
                    this.view.getItems().forEach((v, i) => {
                        _stockItemRows.push({});
                    });

                    Q.postToService({
                        service: StockItemService.baseUrl + '/StockExportExcel',
                        request: {
                            stockRows: _stockItemRows,
                            withBOM: this.withBom
                        },

                        target: '_blank'
                    });*/
                }
            }, TabAurous.Common.ReportHelper.createToolButton({
                title: 'Report(PDF)',
                cssClass: 'export-pdf-button',
                reportKey: 'OMS.LedgerPosting'
            })];
        }
        //protected getColumns() {
        //    var columns = super.getColumns();

        //    Q.first(columns, x => x.field === 'Debit')
        //        .groupTotalsFormatter = (totals, col) =>
        //            (totals.sum ? ('sum: ' + Q.coalesce(totals.sum[col.field], '')) : '');

        //    Q.first(columns, x => x.field === 'Credit')
        //        .groupTotalsFormatter = (totals, col) =>
        //            (totals.sum ? ('sum: ' + Q.coalesce(Q.formatNumber(totals.sum[col.field], '0.'), '')) : '');

        //    return columns;
        //}
        protected markupReady() {
            super.markupReady();
            if (this.autoSize != null) {
                this.autoSize.resizeAllColumns();
            }
        }

        protected getSlickOptions() {
            var opt = super.getSlickOptions();
            opt.showFooterRow = true;
            return opt;
        }

        protected usePager() {
            return true;
        }
    }
}